module.exports = __webpack_public_path__ + "img/profile_credential_010.9916920f.png";